import React from 'react';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { ToastProvider } from 'react-toast-notifications'

import { CLIENT_SETTINGS } from 'src/constants/EndpointUrls';
import BreadCrumb from 'jbc-front/components/BreadCrumb';

import { CLIENT_FORM } from 'src/constants/FormNames';

import { setItem, getItem, getItemErrors } from 'src/reducers/common/itemReducer';
import { REDUCER_NAME, editClient } from 'src/reducers/clients/clients';
import { getSelectOptions } from 'src/reducers/selectOptions';

import ClientForm from './components/ClientForm';
import { useTranslation } from 'react-i18next';


let EditClientForm = reduxForm({
  form: CLIENT_FORM,
})(ClientForm);




const mapStateToProps = state => ({
  initialValues: getItem(REDUCER_NAME, state),
  isNewForm: false,
  errors: getItemErrors(REDUCER_NAME, state)
});
const mapDispatchToProps = dispatch => ({
  onSubmit: data => dispatch(editClient(data))
});
EditClientForm = connect(mapStateToProps, mapDispatchToProps)(EditClientForm);

const EditClient = ({ dispatch, values, anyApiRunning }) => {
  dispatch(setItem(REDUCER_NAME, values));
  const { t } = useTranslation();
  return (
    <div className="l-wrap-xl l-contents-wrap">
      <div className="u-mb20">
        <BreadCrumb>
          <BreadCrumb.Item label={t('components.SideMenu.SideMenu.setting')} path={CLIENT_SETTINGS} />
          <BreadCrumb.Item label={t('features.Clients.EditClient.Edit_office_information')} />
        </BreadCrumb>
      </div>
      <ToastProvider>
        <EditClientForm anyApiRunning={anyApiRunning} />
      </ToastProvider>
    </div>
  );
};


export default connect(state => ({
  anyApiRunning: getSelectOptions(state, 'anyApiRunning')
}))(EditClient);
